<template>
  <div class="project-invoices">
    <!-- Invoice Form Section -->
    <div v-if="showInvoiceForm && editingInvoice" class="invoice-form-section mb-4">
      <div class="card">
        <div class="card-header d-flex justify-content-between align-items-center">
          <h5 class="mb-0">
            {{ editingInvoice.number === '_new' ? $t('invoice_create') : $t('invoice_edit') }}
            <span v-if="editingInvoice.number !== '_new'">
              #{{ editingInvoice.number.toString().padStart(4, '0') }}
            </span>
          </h5>
          <button class="btn btn-sm btn-outline-secondary" @click="closeInvoiceForm">
            <i class="fa fa-times"></i>
          </button>
        </div>
        <div class="card-body">
          <InvoiceForm
            :invoice="editingInvoice"
            :projectContext="project"
            :showCancelButton="true"
            @save="handleSaveInvoice"
            @cancel="closeInvoiceForm"
          />
        </div>
      </div>
    </div>

    <!-- Invoices Table Section -->
    <InvoicesTable
      :projectFilter="project.id"
      :tableStatePrefix="`project-${project.number}-invoices`"
      :showProjectColumn="false"
      @edit-invoice="handleEditInvoice"
      @create-invoice="createNewInvoice"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import InvoicesTable from '@/components/Invoices/InvoicesTable.vue';
import InvoiceForm from '@/components/Invoices/InvoiceForm.vue';

export default {
  name: 'ProjectInvoices',
  components: {
    InvoicesTable,
    InvoiceForm,
  },
  props: {
    project: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      showInvoiceForm: false,
      editingInvoiceNumber: null,
    };
  },
  computed: {
    ...mapGetters(['isLoading', 'getInvoiceByNumber']),

    // Use computed property to always get latest invoice from store
    editingInvoice() {
      if (!this.editingInvoiceNumber) return null;
      return this.getInvoiceByNumber(this.editingInvoiceNumber);
    },
  },
  methods: {
    ...mapActions(['initInvoice', 'createInvoice', 'updateInvoice', 'fetchInvoiceByNumber']),

    async handleEditInvoice(invoice) {
      await this.fetchInvoiceByNumber(invoice.number);
      this.editingInvoiceNumber = invoice.number;
      this.showInvoiceForm = true;
    },

    async handleSaveInvoice(invoice) {
      try {
        if (invoice.number === '_new') {
          await this.createInvoice(invoice);
        } else {
          await this.updateInvoice(invoice);
        }
        this.closeInvoiceForm();
      } catch (error) {
        console.error('Error saving invoice:', error);
      }
    },

    closeInvoiceForm() {
      this.showInvoiceForm = false;
      this.editingInvoiceNumber = null;
    },

    createNewInvoice() {
      this.initInvoice();
      this.editingInvoiceNumber = '_new';
      this.showInvoiceForm = true;
    },
  },
};
</script>

<style scoped lang="scss">
.invoice-form-section {
  .card {
    border: 1px solid #dee2e6;
    border-radius: 0.375rem;

    .card-header {
      background-color: #f8f9fa;
      border-bottom: 1px solid #dee2e6;
      padding: 0.75rem 1rem;

      h5 {
        color: #495057;
        font-weight: 600;
      }
    }

    .card-body {
      padding: 1rem;
    }
  }
}

.project-invoices {
  .btn-outline-secondary {
    border-color: #6c757d;
    color: #6c757d;

    &:hover {
      background-color: #6c757d;
      border-color: #6c757d;
      color: white;
    }
  }
}
</style>
